/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reduce.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSpareEpDetail } from '@/api';
export default {
  props: {
    service: {
      type: Object
    },
    sparePartList: {
      type: [Object, Array]
    },
    moneyItemList: {
      type: [Object, Array]
    },
    extServiceItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    serviceName: function serviceName() {
      var name = this.service.name;

      if (this.service.name.length > 7) {
        name = this.service.name.substring(0, 7) + '...';
      }

      return name;
    },
    otherServiceCost: function otherServiceCost() {
      return this.extServiceItems.reduce(function (p, c) {
        return p + c.service_price * c.service_num;
      }, 0);
    }
  },
  data: function data() {
    return {
      storehouse_type: 0
    };
  },
  created: function created() {
    var _this = this;

    getSpareEpDetail().then(function (res) {
      if (res.success) {
        _this.storehouse_type = res.data.storehouse_type || 0;
      }
    });
  }
};